<mat-form-field>
  <mat-label>{{ 'COMMON.LABEL.TAG' | translate }}</mat-label>
  <mat-select [(ngModel)]="selectedTag" (ngModelChange)="onSelectedTagChange($event)" class="user-tag-selector">
    <mat-select-trigger>
      @if (selectedTagViewModel) {
        <div class="in-select--selected-tag-wrapper">
          <div class="in-select--selected-tag">
            <mat-icon inline [style.color]="selectedTagViewModel.color" class="tags-icon">
              {{ selectedTagViewModel.icon }}
            </mat-icon>
            <span class="selected-tag-label">
              {{ selectedTagViewModel.label | translate }}
            </span>
          </div>
          <mat-icon class="in-select--reset-btn" inline (click)="$event.stopPropagation(); clearSelectedTag()">
            close
          </mat-icon>
        </div>
      } @else {
        {{ 'COMMON.LABEL.FILTER_BY_TAG' | translate }}
      }
    </mat-select-trigger>
    @for (tagViewModel of userTags; track tagViewModel) {
      <mat-option [value]="tagViewModel.name">
        <mat-icon inline [style.color]="tagViewModel.color" class="tags-icon">
          {{ tagViewModel.icon }}
        </mat-icon>
        <span class="option-label">{{ tagViewModel.label | translate }}</span>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
